<template>
  <v-row class="ma-2">
    <div>
      <slot name="custom" :exportData="exportData"></slot>
    </div>
    <div v-if="!$scopedSlots.custom" :style="verticalDirection ? { display: 'flex', flexDirection: 'column' } : {}">
      <v-btn
        v-if="report"
        :loading="loading"
        :disabled="loading"
        icon
        @click="exportData('csv', true)"
      >
        <v-icon title="Full Export to CSV">mdi-book-open-page-variant</v-icon>
      </v-btn>
      <v-btn
        icon
        :loading="loading"
        :disabled="loading"
        @click="exportData('csv')"
      >
        <v-icon title="Export to CSV">mdi-file-delimited</v-icon>
      </v-btn>
      <v-btn
        icon
        :loading="loading"
        :disabled="loading"
        @click="exportData('pdf')"
      >
        <v-icon title="Export to PDF">mdi-file-powerpoint</v-icon>
      </v-btn>
      <v-btn
        icon
        :loading="loading"
        :disabled="loading"
        v-if="$store.state.auth.checkAccess({key: 'export_to_sg', value: true}) && !this.without_sg"
        @click="exportToSG('sendgrid')"
      >
        <v-icon title="Export to Sendgrid" style="transform: scale(1, -1);">mdi-arrange-send-to-back</v-icon>
      </v-btn>
    </div>
  </v-row>

</template>

<script>

  import { map, without } from 'lodash'
  import moment from 'moment'
  import { API } from '@/utils/api'

  export default {
    props: {
      fields: {
        type: Array,
        required: true
      },
      data: {
        type: Array,
        required: true
      },
      reportName: {
        type: String,
        required: true
      },
      project: {
      },
      report: {
        type: Object,
      },
      without_sg: {
        type: Boolean,
        required: false
      },
      verticalDirection: {
        type: Boolean,
        required: false
      }

    },

    data: () => ({
      loading: false,
      mimeTypes: {
        csv: 'text/csv',
        pdf: 'application/pdf',
      }
    }),

    methods: {
      async exportToSG () {
        let input = ''
        if (!(input = await this.$root.$confirm('Confirm', 'Old data from this list will be erased, are you sure?', { promptLabel: 'Sendgrid list name', prompt: this.reportName, width: 360 }))) {
          return
        }

        if (this.fields.indexOf('account_id') == -1) {

          this.$notification.show = true
          this.$notification.message = 'Report without account ids can\'t be exported'
          this.$notification.type = 'error'

          return
        }

        return API.call('/reports/export_sg.json', {
          data: map(this.data, (o) => ({ account_id: o.account_id, login: o.playername || ((o.prefix || '') + o.login) })),
          name: input || this.reportName,
          project: this.project
        }).then(r => {
          this.$notification.show = true
          this.$notification.message = 'Check Sendgrid report list: ' + this.reportName
          this.$notification.type = 'success'
        }).catch(e => {
        })
      },

      exportData (extension, withoutLoading = false) {
        this.loading = true
        if (!this.mimeTypes[extension]) {
          extension = 'csv'
        }

        let formData = new FormData()
        formData.append('export_json', JSON.stringify({
          extension,
          ...(withoutLoading ? {
            report: this.report
          } : {}),
          fields: without(this.fields, 'row_num'),
          data: withoutLoading ? [] : this.data,
          cfg: {
            width: this.fields.length * 100 + 'px',
            height: (this.data.length * 5 < 842 ? 842 : this.data.length * 5) + 'px'
          }
        }))
        return API.call('/reports/export.json', formData, null, null, {
          responseType: 'arraybuffer',
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/pdf'
          }
        }).then(r => this.downloadString(r, this.mimeTypes[extension], (this.reportName || 'report') + '.' + extension)).finally(() => {
          this.loading = false
        })
      },

      downloadString (text, fileType, fileName) {
        let blob = new Blob([ text ], { type: fileType })

        let a = document.createElement('a')
        a.download = fileName
        a.href = URL.createObjectURL(blob)
        a.dataset.downloadurl = [ fileType, a.download, a.href ].join(':')
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        setTimeout(function () {
          URL.revokeObjectURL(a.href)
        }, 1500)
      },

    },

  }
</script>
